// eslint-disable-next-line
import util from 'util';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import cookie from 'cookie';
import * as serviceWorker from './serviceWorker';


/* Check if we're transferring in from the old portal */
let cookies = cookie.parse(document.cookie);
if (cookies.transferIdentity) {
  document.cookie = cookie.serialize('transferIdentity', '',
                                     { path: '/', maxAge : 0 });
  document.cookie = cookie.serialize('transferAccountId', '',
                                     { path: '/', maxAge : 0 });
  ReactDOM.render(<App transferIdentity={cookies.transferIdentity}
                       transferAccountId={cookies.transferAccountId}/>,
                  document.getElementById('root'));
} else {
  ReactDOM.render(<App />, document.getElementById('root'));
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
